<app-authorized-guard
  [authorized]="authorized$ | async"
  message="You are not authorized to view this Organization."
>
  <app-loading-guard [loading]="loading$ | async">
    <div *ngIf="item$ | async as item">
      <div class="organization-details">
        <div class="organization-header">
          <span>{{ item.name }}</span>
          <button
            color="primary"
            *hasPrivilege="'organization/update'"
            mat-raised-button
            routerLink="/organization/edit"
          >
            Edit
          </button>
        </div>
        <dl class="details-list">
          <dt>Address</dt>
          <dd>{{ item.street_address }}</dd>
          <dt>Default homesick days</dt>
          <dd>{{ item.default_homesick_days }}</dd>
        </dl>
        <dl class="preference-list">
          <dt>Organization Preferences</dt>
          <dd>
            <mat-checkbox
              class="preference-checkbox kh-display-checkbox"
              [checked]="item.discover_locations"
              disabled
            >
              Automatically discover locations
            </mat-checkbox>
            <mat-checkbox
              class="preference-checkbox kh-display-checkbox"
              [checked]="item.any_fixed_is_home"
              disabled
            >
              Treat all fixed locations as home
            </mat-checkbox>
          </dd>
        </dl>
      </div>
    </div>
  </app-loading-guard>
</app-authorized-guard>
